module.exports = __webpack_public_path__ + "img/defaultProductIco.d2721bf8.png";